import { useProjectId } from '@config/config.hooks';
import {
  Button,
  Column,
  ComponentType,
  createTableCell,
  createTableColumn,
  ResponsivePaginatedTable,
} from '@gcl/react-core';
import { useFetchLoadingRemovalCertCheckList } from '@permitToLoadRemove/permitToLoadRemove.queries';
import * as React from 'react';
import { convertISOStringToLocalDateString, DISPLAY_DATE_TIME_FORMAT } from '@core/date.services';
import { IProjectLoadingRemovalCertCheckList } from './permitToLoadRemoveDetailPage.models';
import { usePermitToLoadRemovalCheckListDetailModal } from './permitToLoadRemovalCheckListDetailModal.hooks';

interface IPermitToLoadRemovalCheckListProps {
  loadingRemovalCertId: number | undefined;
}
export const PermitToLoadRemovalCheckList: React.FunctionComponent<IPermitToLoadRemovalCheckListProps> = ({
  loadingRemovalCertId,
}) => {
  const projectId = useProjectId();

  const { data, isLoading } = useFetchLoadingRemovalCertCheckList({ projectId }, loadingRemovalCertId);

  const columns = React.useMemo(() => {
    return [
      createTableColumn({
        Header: 'Type',
        disableSortBy: true,
        Cell: createTableCell<string, any>(
          (
            value: string,
            item: IProjectLoadingRemovalCertCheckList,
            index: number,
            cellExtras: { [key: string]: any },
          ) => {
            return <span>{item.checkListType.name}</span>;
          },
        ),
      } as Column),
      createTableColumn({
        Header: 'Inspected By',
        disableSortBy: true,
        Cell: createTableCell<string, any>(
          (
            value: string,
            item: IProjectLoadingRemovalCertCheckList,
            index: number,
            cellExtras: { [key: string]: any },
          ) => {
            return <span>{item.inspectedByProjectUserProfile?.userProfile?.displayName}</span>;
          },
        ),
      } as Column),
      createTableColumn({
        Header: 'Inspected On',
        disableSortBy: true,
        Cell: createTableCell<string, any>(
          (
            value: string,
            item: IProjectLoadingRemovalCertCheckList,
            index: number,
            cellExtras: { [key: string]: any },
          ) => {
            return <span>{convertISOStringToLocalDateString(item.inspectedDateTime, DISPLAY_DATE_TIME_FORMAT)}</span>;
          },
        ),
      } as Column),
      createTableColumn({
        Header: '',
        accessor: 'id',
        disableSortBy: true,
        Cell: createTableCell<string, any>(
          (
            value: string,
            item: IProjectLoadingRemovalCertCheckList,
            index: number,
            cellExtras: { [key: string]: any },
          ) => {
            const { renderModal, openPortal } = usePermitToLoadRemovalCheckListDetailModal({});

            return (
              <>
                <Button onClick={openPortal} small type={ComponentType.Secondary}>
                  Detail
                </Button>
                {renderModal({ checkListDetail: item })}
              </>
            );
          },
        ),
      } as Column),
    ];
  }, []);

  return (
    <>
      {(data ?? []).length > 0 && (
        <ResponsivePaginatedTable allowSelectRow={false} columns={columns} items={data ?? []} disablePagination />
      )}
    </>
  );
};
